import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import BackArrow from "../../../components/backArrow";
import ShopAdds from "../../../components/shopAds/ShopAdds";
import { useGetPublicAgainstShopQuery } from "../../../features/connection/connectionApiSlice";
import Viewbusinessfriend from "../../../pages/UserProfile/Components/Profile_connectivity/Viewbusiness/index";
import Businessprofiletitle from "../../../components/BusinessProfile/Component/Title/businessprofiletitle";
import Rawmaterialcard from "../../../components/BusinessProfile/Component/Rawmaterialcard/Rawmaterialcard";
import Timeline from "../../../components/Timeline/timeline";
import { useParams } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { decodeId } from "../../../utils/idObfuscator";
import useIncomingMessageNotice from "../../../hooks/useIncomingMessageNotice";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import "../../../style/incomingMessageNotice.css";

const RawmaterialHomemade = () => {
  const { id: rawId } = useParams();
  const id = decodeId(rawId);
  const location = useLocation();
  const navigate = useNavigate();
  const [profileshowhide, setProfileshowhide] = useState(false);
  const { name } = useSelector((state) => state.user);
  const { receivedMessageCount, clearReceivedMessageCount } =
    useIncomingMessageNotice({ userId: name?._id, shopId: id });
  const [tabsData, setTabsData] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  const [createPost, setCreatePost] = useState({
    shopid: id,
    userid: name?._id,
    businessType: "homemadeShop",
    my: [
      {
        heading: "",
        content: "",
        img: [""],
        video: [""],
      },
    ],
  });

  const { data: publicData, isLoading: loading } = useGetPublicAgainstShopQuery(
    { businessType: "homemadeShop", shopid: id, userid: name?._id },
    { skip: !id || !name?._id },
  );

  useEffect(() => {
    if (!publicData) return;

    localStorage.setItem("shopid", id);

    const ownBT = createPost?.businessType || "homemadeShop";
    const responseData = publicData?.data || {};
    const dynamicTabs = Object.keys(responseData).map((key) => ({
      eventKey: key,
      title:
        key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1"),
      data: responseData[key],
    }));
    // Own shop area first — shares land here; connected BTs alone hid them.
    const withOwn = dynamicTabs.some((t) => t.eventKey === ownBT)
      ? dynamicTabs
      : [
          {
            eventKey: ownBT,
            title:
              ownBT.charAt(0).toUpperCase() +
              ownBT.slice(1).replace(/([A-Z])/g, " $1"),
            data: [],
          },
          ...dynamicTabs,
        ];
    setTabsData(withOwn);
    setActiveTab((prev) => {
      if (prev && withOwn.some((t) => t.eventKey === prev)) return prev;
      return ownBT;
    });
  }, [publicData, id, createPost?.businessType]);

  const handleTabSelect = (eventKey) => {
    setActiveTab(eventKey);
  };

  const getActiveTabData = () => {
    const activeTabData = tabsData.find((tab) => tab.eventKey === activeTab);
    return activeTabData ? activeTabData.data : [];
  };

  return (
    <>
      <Container>
        <Row className="align-items-start">
          <Col
            lg="7"
            className="screenHeight p-0"
            style={{ backgroundColor: "#fafafa" }}
          >
            {profileshowhide ? (
              <Viewbusinessfriend
                id={id}
                profileurl="/Home-Made-Item-Userprofile"
                setProfileshowhide={setProfileshowhide}
                mybusinessType={createPost?.businessType}
                viewBusinessType={profileshowhide}
              />
            ) : (
              <div className="border b-radius">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 ms-3">
                  <BackArrow back="/Home-Made-Form" />
                  <div className="d-flex align-items-center gap-2 ms-auto">
                    {receivedMessageCount > 0 && (
                      <>
                        <NotificationsActiveIcon
                          className="incoming-message-bell text-primary"
                          fontSize="small"
                          aria-hidden="true"
                        />
                        <span className="small fw-semibold text-primary">
                          {receivedMessageCount} message
                          {receivedMessageCount === 1 ? "" : "s"} received
                        </span>
                      </>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        clearReceivedMessageCount();
                        const chatParams = new URLSearchParams({
                          type: "shop",
                          profileId: id || "",
                          ...(createPost?.businessType
                            ? { businessType: createPost.businessType }
                            : {}),
                          returnTo: location.pathname,
                        });
                        const chatUrl = `/messages?${chatParams.toString()}`;
                        const newTab = window.open(chatUrl, "_blank");
                        if (!newTab) {
                          navigate("/messages", {
                            state: {
                              returnTo: location.pathname,
                              messageProfile: {
                                type: "shop",
                                profileId: id,
                                businessType: createPost?.businessType,
                              },
                            },
                          });
                        }
                      }}
                    >
                      Open chat
                    </button>
                  </div>
                </div>

                <ShopAdds />
                <Businessprofiletitle
                  linkurl="/home-made-owner-profile"
                  name="HomeMade Business Profile"
                  id={id}
                />
                <Rawmaterialcard
                  id={id}
                  profileurl="/Home-Made-Item-Userprofile"
                  setProfileshowhide={setProfileshowhide}
                />
              </div>
            )}
          </Col>

          <Col
            lg="5"
            sm="12"
            className="ps-4 screenHeight"
            style={{ position: "relative" }}
          >
            <div
              className="border b-radius"
              style={{ backgroundColor: "#fafafa" }}
            >
              <Timeline
                tabsData={tabsData}
                activeTab={activeTab}
                onTabSelect={handleTabSelect}
                tabData={getActiveTabData()}
                loading={loading}
                createPost={createPost}
                setCreatePost={setCreatePost}
                id={id}
                mybusinessType={createPost?.businessType}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RawmaterialHomemade;
